import React, { Component, createRef } from 'react';
import img2 from '../../assets/images/googleMap.png';
import { apiEndpoint } from 'helpers/url_helper';
import { Table } from "reactstrap";
import Blink from "react-blink-text";

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.mapRef = createRef();
        this.state = {
            collection: [],
            activeMarker: null,
            showingInfoWindow: false,
            selectedPlace: null,
            status: '',
            cpuTemp: '',
            cpuUsage: '',
            RamPer: '',
            UsagePer: '',
            LastUpadtedTime: '',
            mapBounds: {
                latMin: 10.0, //  southernmost latitude
                latMax: 48.9, // northernmost latitude
                lngMin: 67.5, //  westernmost longitude
                lngMax: 77.9, //  easternmost longitude
            },
        };
    }

    componentDidMount() {
        this.fetchLocationData(this.props.CampusID);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.CampusID !== this.props.CampusID) {
            this.fetchLocationData(this.props.CampusID);
        }
    }

    fetchLocationData = (intCampusID) => {
        if (!intCampusID) return; // Prevent fetching if CampusID is undefined

        const url = apiEndpoint + '/GetLocationList';
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                intCampusID,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                const locations = JSON.parse(result.Locations || '[]');
                this.setState({ collection: locations });
            })
            .catch((error) => console.error('Error fetching locations:', error));
    };

    calculatePosition = (lat, lng) => {
        const { latMin, latMax, lngMin, lngMax } = this.state.mapBounds;
        const x = ((lng - lngMin) / (lngMax - lngMin)) * 100;
        const y = ((latMax - lat) / (latMax - latMin)) * 100;
        return { x, y };
    };

    onMarkerClick = (marker) => {
        const { x, y } = this.calculatePosition(marker.Latitude, marker.Longitude);

        this.setState({
            activeMarker: { ...marker, x, y },
            showingInfoWindow: true,
        });
        const url = apiEndpoint + '/GetLocationData';
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                intLocationID: marker.LocationID,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                 const data = JSON.parse(result.LocationDetails);
                console.log("Fetched Location Data:", data); // Debugging log
                
                const status = data.status === "Online"
                    ? <Blink color="green" fontSize="10" text="Online"></Blink>
                    : <Blink color="red" fontSize="10" text="Offline"></Blink>;
                debugger;
                this.setState({

                    selectedPlace: data.LocationName,
                    cpuTemp: data.CPUTemperature + "°C",
                    cpuUsage: data.CPUUsage + "%",
                    RamPer: data.RamPerc + "%",
                    UsagePer: data.DiskUsagePerc + "%",
                    LastUpadtedTime: new Date(data.TimeStamp).toLocaleString(undefined, {
                        timeZone: 'Asia/Kolkata',   
                    }),
                    status: status,
                });
            })
            .catch((error) => console.error(error));
    };
    closeInfoWindow = () => {
        this.setState({
            showingInfoWindow: false,
            activeMarker: null,
        });
    };

    renderMarkers = () => {
        return this.state.collection.map((marker, index) => {
            const { x, y } = this.calculatePosition(marker.Latitude, marker.Longitude);

            return (
                <div
                    key={index}
                    style={{
                        position: 'absolute',
                        left: `${x}%`,
                        top: `${y}%`,
                        width: '30px',
                        height: '30px',
                        backgroundImage: `url(${marker.Status === 'Online'
                                ? 'https://www.pngplay.com/wp-content/uploads/5/Video-Chat-Camera-Green-Icon-PNG.png'
                                : 'https://media.giphy.com/media/4mML4cVNOKVakSy649/giphy.gif'
                            })`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        transform: 'translate(-50%, -50%)',
                        cursor: 'pointer',
                    }}
                    title={marker.LocationName}
                    onClick={() => this.onMarkerClick(marker)}
                ></div>
            );
        });
    };

    renderInfoWindow = () => {
        const {
            selectedPlace,
            status,
            cpuTemp,
            cpuUsage,
            RamPer,
            UsagePer,
            LastUpadtedTime,
            activeMarker,
            showingInfoWindow,
        } = this.state;

        if (!showingInfoWindow || !activeMarker) return null;

        //const { x, y } = this.calculatePosition(
        //    this.state.activeMarker.Latitude,
        //    this.state.activeMarker.Longitude
        //);

        return (
            <div
                style={{
                    position: 'absolute',
                    left: `${this.state.activeMarker.x}%`,
                    top: `${this.state.activeMarker.y - 5}%`,
                    transform: 'translate(-50%, -120%)',
                    backgroundColor: '#fff',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    //zIndex: 1000,
                }}
            >
                <span
                    onClick={this.closeInfoWindow}
                    style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "black",
                        cursor: "pointer",
                    }}
                >
                    &times;
                </span>
                <div className="table-responsive">
                    <Table className="table mb-0">
                        <thead>
                            <tr>
                                <th style={{ fontSize: "20px" }}>{selectedPlace}</th>
                                <th>{status}</th>
                                <td style={{ fontSize: "smaller" }}>Last Updated: {LastUpadtedTime}</td>
                            </tr>
                        </thead>
                    </Table>
                    <Table className="table mb-0">
                        <tbody>
                            <tr className="table-danger">
                                <td>CPU Temp</td>
                                <td>CPU Usage</td>
                                <td>RAM Used</td>
                                <td>Disk Usage</td>
                            </tr>
                            <tr className="table-light">
                                <td>{cpuTemp}</td>
                                <td>{cpuUsage}</td>
                                <td>{RamPer}</td>
                                <td>{UsagePer}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <img
                    src={img2}
                    alt="Static Map"
                    ref={this.mapRef}
                    style={{ width: '100%', height: '100%' }}
                />
                {this.renderMarkers()}
                {this.renderInfoWindow()}
            </div>
        );
    }
}

export default MapContainer;
